exports.Collapse = require('./Collapse')
exports.Item = require('./Item')



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-collapse/src/index.js
// module id = 203
// module chunks = 0